import React from "react";
import { motion } from "framer-motion";
import { MapPin, ShieldCheck } from "lucide-react";
import { BIZ } from "./psoData";
import PsoLayout, { NAVY, EMERALD, CREAM, SLATE } from "./PsoLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function PsoLocations() {
  return (
    <PsoLayout active="locations">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#6EE7B7" }}>Locations</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">One Firm, Metro Manila-Wide</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <h3 className="font-bold text-sm uppercase tracking-wide mb-2 flex items-center gap-2" style={{ color: EMERALD }}><MapPin size={16} /> Main Office</h3>
            <p className="text-sm" style={{ color: SLATE }}>{BIZ.address}</p>
          </motion.div>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm mb-6">
            <h3 className="font-bold text-sm uppercase tracking-wide mb-2" style={{ color: EMERALD }}>Also Serving</h3>
            <div className="flex flex-wrap gap-2">
              {BIZ.serviceAreas.map((a) => <span key={a} className="text-xs font-medium rounded-full px-3.5 py-1.5" style={{ background: CREAM, color: NAVY }}>{a}</span>)}
            </div>
          </motion.div>
          <motion.div {...fadeUp} className="flex items-start gap-2.5 rounded-lg p-4 text-xs bg-white">
            <ShieldCheck size={16} className="shrink-0 mt-0.5" style={{ color: EMERALD }} />
            One authoritative office presence, instead of the fragmented location-by-location listings our current web presence is spread across.
          </motion.div>
        </div>
      </section>
    </PsoLayout>
  );
}
